import { storeToRefs } from 'pinia';

export { useRuleGroups } from './use-rule-groups';
export { useCommonSettings } from './use-common-settings';
export { useAppearanceSettings } from './use-appearance-settings';
export { useNotifySettings } from './use-notify-settings';
import {
  useUILayoutSettingsStore,
  useUILayoutSettingsSetters,
} from './use-ui-layout-settings-store';
import { useUILayoutSettingsActions } from './use-ui-layout-settings-actions';
export { UISettingsUpdateToastType } from './use-ui-layout-settings-actions';

export const useUILayoutSettings = () => {
  return {
    ...storeToRefs(useUILayoutSettingsStore()),
    ...useUILayoutSettingsSetters(),
    ...useUILayoutSettingsActions(),
  };
};
